/* eslint-disable react/no-children-prop */
import React from 'react'
import { connect } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import ReactMarkdown from 'react-markdown'
// Local
import ConditionAddressedDate from '../common/conditionAddressedDate'
import ConditionEvidence from '../common/conditionEvidence'
import { EncounterConditionDisplay } from '../../authenticated/types'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>


type Props = ReduxStateProps & {
  condition: EncounterConditionDisplay
}

function CdiConditionDetail(
  props: Props
) {
  const {
    condition,
    currentUser
  } = props

  return (
    <Grid.Row className="first-row">
      <Grid.Column>
        <div>
          <ConditionEvidence
            condition={ condition }
            currentUser={ currentUser }
          />
          <ReactMarkdown
            children={ condition.content as string }
            linkTarget="_blank"
          />
          <ConditionAddressedDate condition={ condition } />
        </div>
      </Grid.Column>
    </Grid.Row>
  )
}

export default connect(mapStateToProps)(CdiConditionDetail)
